export default [
  {
    path: '/employee-card-activators',
    name: 'employee-card-activator',
    meta: { requiresAuth: true },
    component: () => import('@/pages/employee-card-activator/index-v2.vue')
  }
]
